const { formatText } = require('core/i18n').i18n;

const translateExantCostKey = (exantCosts, context, typeToValidate = '', auxContext = '') => {
    if (!!exantCosts) {
        return exantCosts.map(cost => {
            let costTranslated;
            if (cost.type === 'SECTION') {
                costTranslated = {
                    ...cost,
                    descriptionKey: formatText(`${context}-${cost.descriptionKey}`),
                    details: !!cost.details ? translateExantCostKey(cost.details, context) : null,
                    total: !!cost.total ? {
                        ...cost.total,
                        descriptionKey: formatText(`${context}-${cost.total.descriptionKey}`),
                    } : null,
                };
            } else if (cost.type === 'FOOTNOTE') {
                costTranslated = {
                    ...cost,
                    details: !!cost.details ? translateExantCostKey(cost.details, context) : null,
                    descriptionKey: formatText(`${context}-${cost.descriptionKey}Footnote`),
                };
            } else if (cost.type === typeToValidate) {
                costTranslated = {
                    ...cost,
                    descriptionKey: formatText(`${auxContext}-${cost.descriptionKey}`),
                    details: !!cost.details ? translateExantCostKey(cost.details, auxContext, typeToValidate, auxContext) : null,
                    total: !!cost.total ? {
                        ...cost.total,
                        descriptionKey: formatText(`${context}-${cost.total.descriptionKey}`),
                    } : null,
                };
            } else {
                costTranslated = {
                    ...cost,
                    details: !!cost.details ? translateExantCostKey(cost.details, context) : null,
                    descriptionKey: formatText(`${context}-${cost.descriptionKey}`),
                };
            }
            return costTranslated;
        });
    }else{
        return null;
    }
}

module.exports = translateExantCostKey
